export const LAYOUT_EDIT = 'edit';
export const LAYOUT_SPLIT = 'split';
export const LAYOUT_MARKDOWN = 'markdown';

export const LAYOUTS = [LAYOUT_EDIT, LAYOUT_SPLIT, LAYOUT_MARKDOWN];
